import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, ListItemText, ListItem, List } from "@material-ui/core";
import Modal from "../../components/dialog/Modal";
import { withTranslation } from "react-i18next";

class DeleteModal extends React.Component {
  constructor(props) {
    super(props);

    this.retrieveData = this.retrieveData.bind(this)
  }

  retrieveData() {
    const data = [];
    const dataList = this.props.data
    Object.keys(dataList).forEach(key => {
      const tag = dataList[key];
      data.push({ id: tag.id, value: tag.Name });
    });

    return data
  }

  render() {
    const itemsToDelete = this.retrieveData();

    return (
      <Modal
        title={this.props.t('common.confirm-delete')}
        open={this.props.open}
        actions={
          <div>
            <Button color="default" onClick={this.props.handleCancel}>
              {this.props.t('common.cancel')}
            </Button>
            <Button
              color="primary"
              onClick={() => this.props.handleDone(this.props.data)}
            >
              {this.props.t('common.delete')}
            </Button>
          </div>
        }
      >
        <List>
          {itemsToDelete.map((dataItem) => {
            return (
              <ListItem
                key={dataItem?.id || dataItem}
                role={undefined}
                dense
              >
                <ListItemText id={dataItem.id} primary={dataItem.value} secondary={dataItem.id} />
              </ListItem>
            );
          })}
        </List>
      </Modal>
    );
  }
}

const hoc = withTranslation()(DeleteModal)

// EXPORT COMPONENT

export { hoc as DeleteModal };
